<template>
  <v-dialog v-model="showDialog">
    <template v-slot:activator="{ on }">
      <slot v-bind="{ on }"></slot>
    </template>
    <v-card>
      <v-card-title class="headline">
        {{ $t('Preview video') }}
      </v-card-title>
      <v-card-text>
        <div class="text-xs-center">
          <video :src="videoUrl" controls style="width: 100%"></video>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="showDialog = false">
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['videoUrl'],
  data: function() {
    return {
      showDialog: false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/DialogPreviewVideo.vue